<div class="flex-column align-start-none full-width gap-1em">
    <div class="flex-column align-start-none gap-1em">
        <div class="flex-row gap-1em">
            <span class="subtitle-3 text-primary-darker">{{ 'modules.providers.patient-data.paciente' | exp:'':'Paciente' }}</span>
            <span class="subtitle-4">{{ this.fullName() }}</span>
        </div>
        <div class="flex-row gap-1em">
            <span class="subtitle-3 text-primary-darker">{{ 'modules.providers.patient-data.practica' | exp:'':'Práctica' }}</span>
            <span class="subtitle-4">{{ !!this.pratice() ? this.pratice().name : ('modules.providers.patient-data.sin-especificar' | exp:'':'Sin especificar') }}</span>
        </div>
        <div class="flex-row gap-1em">
            <span class="subtitle-3 text-primary-darker">{{ 'modules.providers.patient-data.especialidad' | exp:'':'Especialidad' }}</span>
            <span class="subtitle-4">{{ !!this.specialty() ? this.specialty() : ('modules.providers.patient-data.sin-especificar' | exp:'':'Sin especificar') }}</span>
        </div>
    </div>
</div>
